"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var getNextStep = function getNextStep(a, b, c) {
    var d = a + 1,
      e = b[a - 1];
    return !!c[e] && (!0 === c[e].hideField && (d = getNextStep(d)), d);
  },
  _default = exports["default"] = getNextStep;